import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getAll () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'premium/list',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/premiumservice.js